import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const carryBagApi = createApi({
  reducerPath: 'carryBagApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['CarryBag'],
  endpoints: (builder) => ({

    getCarryBags: builder.query({
      query: () => '/carry_bags',
      providesTags: [{ type: 'CarryBag', id: 'LIST' }],
    }),

  }),
});

export const {
  useGetCarryBagsQuery,
  useLazyGetCarryBagsQuery,
} = carryBagApi;
